<div class="background">
  <div *ngIf="!loginDisplay"></div>
  <div *ngIf="loginDisplay">
    <div class="content">
      <app-locations></app-locations>
    </div>
  </div>
</div>
